const app = {
  http_url: process.env.NODE_ENV === 'development' ? '/dev' : 'https://yunseat.ruanjiesh.com', //   测试用: /dev  正式用: /
  //http_url: process.env.NODE_ENV === 'development' ? '/dev' : 'https://yzx.zf-ggyy.com', //   测试用: /dev  正式用: /
  //http_url: process.env.NODE_ENV === 'development' ? '/dev' : 'https://yunseat.shangjieiot.com', //   测试用: /dev  正式用: /
  timeout: 1000 * 60 //请求超时时间
}
export default app;
